<template>
  <Layout>

    <!-- sr-only H1 for SEO: visible to crawlers, zero visual impact -->
    <h1 class="sr-only">
      {{ reference
        ? 'Résultats pour "' + reference + '"'
        : $route.params.subgroup
          ? ($route.params.subgroup + ' ' + $route.params.section)
          : $route.params.group
            ? ($route.params.group + ' ' + $route.params.section)
            : $route.params.section
              ? ('Collection ' + $route.params.section)
              : 'Catalogue HA' }}
    </h1>

    <!-- <Banner v-if="!reference && !selectedSubGroupName" :pageTitle="pageTitle ? pageTitle :'Notre Catalogue'" :bannerImageName="bannerImageName" :small="true" ></Banner> -->

    <Shop @bannerTitle="bannerTitle" @catalogBannerImage="catalogBannerImage" > </Shop>





  </Layout>


  

  
</template>

<script>
import Layout from "../../layouts/main";
//import Banner from "@/components/banner.vue"
import Shop from "@/components/shopComponent.vue"

export default ({
  name: "Catalogue",
  page() {
    const { section, group, subgroup } = this.$route.params;

    let description = 'Découvrez toutes les collections HA - boutique de mode prêt-à-porter en ligne en Tunisie.';
    if (section && !group) {
      description = `Collection ${section} HA - Mode prêt-à-porter et accessoires. Boutique en ligne, livraison en Tunisie.`;
    } else if (section && group && !subgroup) {
      description = `${group} ${section} HA - Retrouvez notre sélection tendance. Boutique en ligne, livraison en Tunisie.`;
    } else if (section && group && subgroup) {
      description = `${subgroup} ${section} HA - Mode et accessoires tendance. Boutique en ligne, livraison en Tunisie.`;
    }

    let pageTitle = 'Catalogue HA';
    if (section && !group)             pageTitle = `Collection ${section}`;
    else if (section && group && !subgroup) pageTitle = `${group} ${section}`;
    else if (section && group && subgroup)  pageTitle = `${subgroup} ${section}`;
    pageTitle = pageTitle.replace(/\b\w/g, c => c.toUpperCase());

    const ogTitle = `${pageTitle} | HA, Boutique en ligne, Tunisie`;
    const pageUrl = `https://ha.com.tn${this.$route.path}`;

    // --- JSON-LD: BreadcrumbList + CollectionPage ---
    const slugToLabel = s => s ? s.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase()) : s;

    const breadcrumbItems = [
      { '@type': 'ListItem', position: 1, name: 'Accueil', item: 'https://ha.com.tn/' }
    ];
    if (section)  breadcrumbItems.push({ '@type': 'ListItem', position: 2, name: slugToLabel(section),  item: `https://ha.com.tn/catalogue/${section}` });
    if (group)    breadcrumbItems.push({ '@type': 'ListItem', position: 3, name: slugToLabel(group),    item: `https://ha.com.tn/catalogue/${section}/${group}` });
    if (subgroup) breadcrumbItems.push({ '@type': 'ListItem', position: 4, name: slugToLabel(subgroup), item: `https://ha.com.tn/catalogue/${section}/${group}/${subgroup}` });

    const ldScripts = [
      {
        id: 'ldjson-breadcrumb',
        type: 'application/ld+json',
        innerHTML: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: breadcrumbItems
        })
      },
      {
        id: 'ldjson-collection',
        type: 'application/ld+json',
        innerHTML: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'CollectionPage',
          name: pageTitle,
          description: description,
          url: pageUrl,
          publisher: { '@type': 'Organization', name: 'HA', url: 'https://ha.com.tn' }
        })
      }
    ];

    return {
      title: pageTitle,
      titleTemplate: '%s | HA, Boutique en ligne, Tunisie',
      meta: [
        { vmid: 'description',         name: 'description',            content: description },
        { vmid: 'og:title',            property: 'og:title',           content: ogTitle },
        { vmid: 'og:description',      property: 'og:description',     content: description },
        { vmid: 'og:url',              property: 'og:url',             content: pageUrl },
        { vmid: 'twitter:title',       name: 'twitter:title',          content: ogTitle },
        { vmid: 'twitter:description', name: 'twitter:description',    content: description },
      ],
      link: [{ vmid: 'canonical', rel: 'canonical', href: pageUrl }],
      script: ldScripts,
      __dangerouslyDisableSanitizersByTagID: {
        'ldjson-breadcrumb':  ['innerHTML'],
        'ldjson-collection':  ['innerHTML']
      }
    };
  },

  components: {
    Layout, /*Banner,*/ Shop
  },

  props: {
        
    },

    data() {
        return { 
            reference: null,
            pageTitle:null,
            selectedSubGroupName:null,
            bannerImageName:null,
        }
    },

    watch :{

        '$route': {
            immediate: true,
            deep: true, 
            handler(route) {
              this.selectedSubGroupName = route.params.subgroup;

                if (route.query.keyword) {
                    this.reference = route.query.keyword;
                } else {
                    this.reference = null;
                }
            }
        },

        

    },


  mounted() {
  },

  methods: {

    bannerTitle(bannerTitle ){
      this.pageTitle = bannerTitle

    },

    catalogBannerImage(bannerImageName){
      this.bannerImageName = bannerImageName
    }
  },


});
</script>

<style scoped>

</style>



